import { render, staticRenderFns } from "./qaDetail.vue?vue&type=template&id=08073164&"
import script from "./qaDetail.vue?vue&type=script&lang=js&"
export * from "./qaDetail.vue?vue&type=script&lang=js&"
import style0 from "./qaDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports